import { render, staticRenderFns } from "./areaed.vue?vue&type=template&id=8d939b12&scoped=true&"
import script from "./areaed.vue?vue&type=script&lang=js&"
export * from "./areaed.vue?vue&type=script&lang=js&"
import style0 from "./areaed.vue?vue&type=style&index=0&id=8d939b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d939b12",
  null
  
)

export default component.exports